(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["consumersignupnodeweb"] = factory();
	else
		root["consumersignupnodeweb"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/